module.exports = __webpack_public_path__ + "static/c15-711c3bfe51d1b2853cfd37f7d279b25b.jpg";